import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/analytics`;

export const analyticsService = {
  recordVisit: async () => {
    try {
      await axios.post(`${API}/visit`, { page: 'catalog' });
    } catch {
      // silent fail - analytics should not block UX
    }
  },

  recordWhatsAppClick: async (puppyId, puppyName, breed) => {
    try {
      await axios.post(`${API}/whatsapp-click`, {
        puppy_id: puppyId,
        puppy_name: puppyName,
        breed: breed
      });
    } catch {
      // silent fail
    }
  },

  getStats: async (token) => {
    const response = await axios.get(`${API}/stats`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};
